import { render } from "./PortfolioFilterBody.vue?vue&type=template&id=0f86cfe6"
import script from "./PortfolioFilterBody.vue?vue&type=script&lang=js"
export * from "./PortfolioFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__